import ProfileDetailsTab from './components/ProfileDetailsTab';

function ProfileDetails() {
  return (
    <div className='flex flex-col p-6 pb-24 h-full overflow-auto'>
      <ProfileDetailsTab />
    </div>
  );
}

export default ProfileDetails;
